// Fields that only ever appear in a deactivation-flow fingerprint (either the
// deactivation request key, or the confirmation payload the customer's
// client sends back). None of these are ever present in an activation-flow
// fingerprint.
const DEACTIVATION_ONLY_FIELDS = [
  "deactivationRequestId",
  "usageSnapshot",
  "requestedByEmail",
  "deactivatedAt",
  "deactivated",
  "issuedAt",
  "expiresAt",
];

// Fields that only ever appear in an activation-flow fingerprint (either the
// server-issued activation key, or the raw hardware fingerprint the client
// agent generates for the activate-a-machine flow). None of these are ever
// present in a deactivation-flow fingerprint.
const ACTIVATION_ONLY_FIELDS = [
  "activationEmail",
  "activationExpiryDate",
  "licenseInfo",
  "usageFingerprint",
];

const presentFields = (parsed: Record<string, any>, fields: string[]): string[] =>
  fields.filter((field) => parsed[field] !== undefined && parsed[field] !== null);

export const assertIsActivationFlowFingerprint = (parsed: Record<string, any>): void => {
  const found = presentFields(parsed, DEACTIVATION_ONLY_FIELDS);
  if (found.length > 0) {
    throw new Error(
      `This fingerprint belongs to the deactivation flow, not activation (found field(s): ${found.join(
        ", "
      )}). Paste a fingerprint generated for activation instead.`
    );
  }
};

export const assertIsDeactivationFlowFingerprint = (parsed: Record<string, any>): void => {
  const found = presentFields(parsed, ACTIVATION_ONLY_FIELDS);
  if (found.length > 0) {
    throw new Error(
      `This fingerprint belongs to the activation flow, not deactivation (found field(s): ${found.join(
        ", "
      )}). Paste the fingerprint the customer sent back to confirm deactivation instead.`
    );
  }
};
